import React, { useContext, useEffect } from 'react';
import { NationalRadarService } from '../../services/nationalRadar/NationalRadar';
import loadingContext from '../../context/loadingContext';

interface NationalAnimationProps {
    service?: NationalRadarService | null,
    setIsPlayingNationalRadar?: (value: (((prevState: boolean) => boolean) | boolean)) => void,
    isPlayingNationalRadar?: boolean
}

export const NationalAnimation = ({ service, setIsPlayingNationalRadar,isPlayingNationalRadar }: NationalAnimationProps) => {
    const setLoading = useContext(loadingContext);
    
    const startAnimation = () => {
        if (service && !isPlayingNationalRadar) {
            service.startAnimation();
            setIsPlayingNationalRadar && setIsPlayingNationalRadar(true);
        }
    }
    
    const stopAnimation = () => {
        if (service) {
            service.stopAnimation();
            setIsPlayingNationalRadar && setIsPlayingNationalRadar(false);
        }
    }

    
    useEffect(() => {
        startAnimation();
        return () => {
            stopAnimation();
        }
    }, []);
    return (
        <>
        </>
    );
}
